import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

import { ImportModalComponent } from 'components/RootModal/modalRegistry';

export const INVOICE_FORM_ROOTUI_TYPE = 'INVOICE_FORM_DIALOG';
ImportModalComponent(INVOICE_FORM_ROOTUI_TYPE, () => import('./index'));

// @ts-expect-error FIXME TS7006
export const InvoiceFormUpsertAction = createAction(rootUiActions.createDialog.toString(), (props) =>
  rootUiTypes.mkRootUiData({
    type: INVOICE_FORM_ROOTUI_TYPE,
    props: ImmutableMap({
      blankInvoice: props.blankInvoice ?? false,
      context: props.context,
      customerId: props.customerId ?? '',
      initialView: props.initialView ?? 'Edit',
      projectId: props.projectId ?? '',
      subtype: props.subtype,
      titleProp: props.titleProp ?? 'Invoice',
      invoiceId: props.invoiceId,
    }),
  }),
);
